import React from "react";
//import Banner from "../components/Banner"; // Adjust path accordingly
import TopFold from "./TopFold.js";
import Footer from "./Footer.js";
import Investment from "./Investment.js";


const HomePage = () => {
    return (
        <div>
            {/*<Banner />*/}
            <TopFold />
            <Investment />
            <Footer />
        </div>
    );
};

export default HomePage;